import './featured-collection-slider.css';
import 'swiper/css';
import Swiper from 'swiper';

export default () => {
  let swiperInstance = null;

  const init = () => {
    if (!customElements.get("featured-collection-slider")) {
      customElements.define("featured-collection-slider", FeaturedSlider);
    }
  };

  class FeaturedSlider extends HTMLElement {
    constructor() {
      super();
      this.mainSlider = this.querySelector(".featured-collection__swiper");
      this.initializeSwiper = this.initializeSwiper.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    initializeSwiper() {
      // Destroy existing Swiper instance if it exists
      if (swiperInstance !== null) {
        swiperInstance.destroy(true, true);
      }

      // Reinitialize Swiper with updated settings
      if (this.mainSlider) {
        swiperInstance = new Swiper(this.mainSlider, {
          direction: 'horizontal',
          centeredSlides: false,
          autoHeight: true,
          spaceBetween: 0,
          loop: true,
          breakpoints: {
            990: {
              loop: false,
              slidesPerView: 3,
              autoHeight: true,
              centeredSlides: false,
              grid: {
                rows: 3
              }
            },
            500: {
              loop: false,
              slidesPerView: 2.35,
              autoHeight: true,
              centeredSlides: false,
              grid: {
                rows: 3
              }
            },
            300: {
              loop: false,
              slidesPerView: 1.35,
              autoHeight: true,
              centeredSlides: false,
              grid: {
                rows: 3
              }
            }
          }
        });
      }
    }

    onResize() {
      this.initializeSwiper();
    }

    connectedCallback() {
      this.initializeSwiper();
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (swiperInstance !== null) {
        swiperInstance.destroy(true, true);
      }
    }
  }

  init();
}
